export default "__VITE_ASSET__CzY37xJm__"